import { Row, Col, Card, Icon, Form, Input, Select, DatePicker, Radio } from 'antd';
import { personal } from './formConfig';
import { ssFormUtils, ssFormValidationUtils, ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';
import { grouped } from '../../../../utils/utils';

const
config = personal,
{ key } = config,
{ generateFormItem, generateInputComponent, generateOptionFromCommonData, generateRadioFromCommonData } = ssFormUtils,
{ validateForm, validateSubForm } = ssFormValidationUtils;

export default class Personal extends React.Component {
    state = { isValid: false }
    constructor(props) { super(props); }

    componentDidUpdate(prevProps) {
        const
        { services, registrationForm } = this.props,
        form = registrationForm[key],
        prevForm = prevProps.registrationForm[key],
        { storeForm } = services;

        if(!ssCommonUtils.simpleObjectCompare(prevForm, form)) {
            const formState = validateForm(form, config, true);
            storeForm(key, formState);
            this.setState({ isValid: validateSubForm(formState) });
        }
    }

    setMaxWidth = d => ({...d, style: { width: '100%' }});

    render() {
        const
        { services, registrationForm, commonData } = this.props,
        form = registrationForm[key],
        { lookupData } = commonData,
        { storeForm, storeFormField } = services;

        return (
            <div>
                <Row type='flex' justify='space-around' align='middle'>
                    <Col span={21}>
                        <Card hoverable style={{ cursor: 'default' }} bodyStyle={{ padding: '10px' }}>
                            <Icon type='info-circle-o' style={{ fontWeight: 'bold', marginRight: '6px' }} />
                            {'Please enter the following information '}
                            <span style={{ fontWeight: 'bold' }}>
                                {'EXACTLY'}
                            </span>
                            {' as it appears on your current, valid passport or other provided identification. '}
                            {'Any discrepancies will delay the process until corrected.'}
                        </Card>
                    </Col>
                </Row>
                <Row type='flex' justify='space-around' align='middle'>
                    <Col span={21}>
                        <Form>
                            <Row type='flex' justify='space-around' align='middle' gutter={10}>
                                <Col span={6}>
                                    <Form.Item {...generateFormItem('firstName', config, form)}>
                                        <Input {...this.setMaxWidth(generateInputComponent('firstName', config, true, form, storeFormField, storeForm))} />
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item {...generateFormItem('middleName', config, form)}>
                                        <Input {...this.setMaxWidth(generateInputComponent('middleName', config, true, form, storeFormField, storeForm))} />
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item {...generateFormItem('lastName',  config, form)}>
                                        <Input {...this.setMaxWidth(generateInputComponent('lastName', config, true, form, storeFormField, storeForm))} />
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item {...generateFormItem('nameSuffix', config, form)}>
                                        <Select {...this.setMaxWidth(generateInputComponent('nameSuffix', config, true, form, storeFormField, storeForm))}>
                                            {generateOptionFromCommonData(grouped(lookupData.lookupDataStore['NAME_SUFFIX_CD'], 'Legacy'))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={10}>
                                <Col span={6}>
                                    <Form.Item {...generateFormItem('dob',  config, form)}>
                                        <DatePicker {...this.setMaxWidth(generateInputComponent('dob', config, true, form, storeFormField, storeForm))}/>
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item {...generateFormItem('dobType',  config, form)}>
                                        <Radio.Group {...this.setMaxWidth(generateInputComponent('dobType', config, true, form, storeFormField, storeForm))}>
                                            {generateRadioFromCommonData(lookupData.lookupDataStore['DATE_TYPE_CD']).reverse()}
                                        </Radio.Group>
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item {...generateFormItem('phoneNumber',  config, form)}>
                                        <Input {...this.setMaxWidth(generateInputComponent('phoneNumber', config, true, form, storeFormField, storeForm))}/>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
            </div>
        )
    }
}
